"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _SttBox = _interopRequireDefault(require("../../SttLayout/SttBox"));
var _UserInfo = _interopRequireDefault(require("./UserInfo"));
var _styles = require("@material-ui/core/styles");
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _excluded = ["config"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuUsuario: {
      right: 10
    },
    boxMenuUsuario: {
      display: 'flex',
      flexFlow: 'column wrap',
      alignItems: 'center',
      padding: 0,
      spacing: 0,
      height: '264px',
      width: '232px'
    },
    avatar: {
      width: 20,
      height: 20,
      border: '1px solid gray'
    },
    nome: {
      color: '#828282',
      fontSize: '0.85rem',
      fontWeight: '400'
    },
    email: {
      color: '#828282',
      fontSize: '0.70rem',
      fontWeight: '400'
    },
    botaoMeusDados: {
      marginTop: theme.spacing(2)
    },
    botaoSair: {
      marginTop: theme.spacing(2)
    }
  };
});
var StyledMenu = (0, _styles.withStyles)({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, props));
});
var MenuUsuario = function MenuUsuario(_ref) {
  var config = _ref.config,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    _anchorEl = _useState2[0],
    handleanchorEl = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    imageSrc = _useState4[0],
    setImageSrc = _useState4[1];
  var handleClickMenuUsuario = function handleClickMenuUsuario(event) {
    handleanchorEl(event.currentTarget);
  };
  var handleCloseMenuUsuario = function handleCloseMenuUsuario() {
    handleanchorEl(null);
  };
  (0, _react.useEffect)(function () {
    var messageListener = function messageListener(event) {
      var _event$data, _event$data2;
      var acao = ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.acao) || null;
      var data = ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.data) || null;
      if (acao === 'IMAGEM_USUARIO') {
        setImageSrc(data);
      }
    };
    window.addEventListener("message", messageListener);

    // clean up
    return function () {
      return window.removeEventListener("message", messageListener);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    disableRipple: true,
    size: "small"
  }, props, {
    className: classes.menuUsuario,
    onClick: handleClickMenuUsuario
  }), imageSrc ? /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    src: imageSrc,
    className: classes.avatar
  }) : /*#__PURE__*/_react["default"].createElement(_AccountCircle["default"], null)), /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    id: "customized-menu",
    anchorEl: function anchorEl() {
      return _anchorEl;
    },
    keepMounted: true,
    open: Boolean(_anchorEl),
    onClose: handleCloseMenuUsuario
  }, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: classes.boxMenuUsuario
  }, /*#__PURE__*/_react["default"].createElement(_UserInfo["default"], {
    config: config
  }))));
};
var _default = MenuUsuario;
exports["default"] = _default;